import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { CardEntity } from '../../ducks/cards/types'
import { CardsActions } from '../../ducks/cards/actions'
import { ModalsActions } from '../../ducks/modals/actions'
import { ActressesActions } from '../../ducks/actresses/actions'
import { QueryType } from '../../ducks/actresses/types'
import { initialStateType as ActressInitialStateType } from '../../ducks/actresses/reducers'
import ResultPageContents from './ResultPageContents'

interface InitialStateType {
  cards: CardEntity[]
  modals: CardEntity[]
  actresses: ActressInitialStateType
}

function mapStateToProps(state: InitialStateType) {
  return {
    cards: state.cards,
    modals: state.modals,
    actresses: state.actresses
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    swipeCard: () => dispatch(CardsActions.swipeCard()),
    addModal: (card: CardEntity) => dispatch(ModalsActions.addModal(card)),
    resetModal: () => dispatch(ModalsActions.resetModal()),
    searchActresses: (query: QueryType) => dispatch(ActressesActions.searchActresses.started(query))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultPageContents)
